import { useContext, useMemo } from 'react';

import { NavigationContext, NavigationContextType } from 'src/app/navigation';

const WorkspaceLayout = () => {
  const navContextValue: NavigationContextType = useMemo(
    () => ({
      navigationType: 'product',
      mobileHeading: '',
    }),
    []
  );

  const { setNavContextValue } = useContext(NavigationContext);
  setNavContextValue?.(navContextValue);

  return null;
};
export default WorkspaceLayout;
